import $ from 'jquery';
import JQueryView, { on } from '@/common/views/jqueryView';

export default class AgreementFormView extends JQueryView {
  edit_mode: boolean;
  constructor(edit_mode: boolean) {
    super('#user_individual_agreement_form');

    this.edit_mode = edit_mode;

    this.disabledNewCheckbox();
    this.scrollfunc();
    this.resizerWindow();
  }

  @on({ event: 'change', selector: '.js-agreements-term' })
  onChangeToggleAgreement(e: JQuery.ChangeEvent) {
    const checked = $(e.currentTarget).prop('checked');

    $('#user_investor_agreement_attributes_pdf1').prop('checked', checked);
    $('#user_investor_agreement_attributes_pdf2').prop('checked', checked);
    $('#user_investor_agreement_attributes_pdf3').prop('checked', checked);
    $('#user_investor_agreement_attributes_pdf5').prop('checked', checked);

    this.cleanErrorMsg(e);
  }

  @on({ event: 'change', selector: '.js-agreements-policy' })
  onChangeTogglePrivacyPolicy(e: JQuery.ChangeEvent) {
    this.cleanErrorMsg(e);
  }

  @on({ event: 'change', selector: '.js-agreements-peps' })
  onChangeTogglePeps(e: JQuery.ChangeEvent) {
    const checked = $(e.currentTarget).prop('checked');

    $('#user_investor_pep_attributes_country').prop('checked', checked);
    $('#user_investor_pep_attributes_japanese_permanent_at_registration').prop(
      'checked',
      checked,
    );
    $('#user_investor_pep_attributes_fatca').prop('checked', checked);
    $('#user_investor_pep_attributes_peps').prop('checked', checked);

    this.cleanErrorMsg(e);
  }

  cleanErrorMsg(e: JQuery.ChangeEvent) {
    const error = e.currentTarget.closest('.js-agreement-group.is-invalid');

    // 同意チェック時に、エラーメッセージが表示されていたら消す
    if ($(e.currentTarget).prop('checked') && error) {
      $(error).removeClass('is-invalid');
      $(error).addClass('is-active');

      $(error).children('.agreements-checkbox-error').remove();
    }
  }

  disabledNewCheckbox() {
    const $term = $('#agreements-term');
    const $policy = $('#agreements-policy');

    if ($term.closest('.js-agreement-group').hasClass('is-invalid')) {
      // エラーならそのまま
    } else if (!this.edit_mode && !$term.prop('checked')) {
      // 初期表示モードかつ未同意ならばチェックをを非活性にする
      $term.prop('disabled', true);
      $term.closest('.js-agreement-group').addClass('is-inactive');
    } else {
      $('#agreements-term')
        .closest('.js-agreement-group')
        .addClass('is-active');
    }

    if ($policy.closest('.js-agreement-group').hasClass('is-invalid')) {
      // エラーならそのまま
    } else if (!this.edit_mode && !$policy.prop('checked')) {
      $policy.prop('disabled', true);
      $policy.closest('.js-agreement-group').addClass('is-inactive');
    } else {
      $policy.closest('.js-agreement-group').addClass('is-active');
    }
  }

  activateDocAndCheckbox(el: HTMLElement) {
    const $baseNode = $(el).closest('.js-agreement-group');
    if (!$baseNode) return;
    if ($baseNode.hasClass('is-active')) return;
    if ($baseNode.hasClass('is-invalid')) return;

    $baseNode.removeClass('is-inactive');
    $baseNode.addClass('is-active');
    $baseNode.find('.js-agreements-checkbox').prop('disabled', false);
  }

  scrollfunc() {
    // スクロールはバブリングで発火しないので個々バインドする
    $('.js-agreements-document').on('scroll', e => {
      this.activateDocAndCheckbox(e.currentTarget);
    });
  }

  @on({ event: 'click', selector: '.js-modal-open1' })
  onClickOpenModal1() {
    $('.js-modal1').addClass('is-active');
  }

  @on({ event: 'click', selector: '.js-modal1' })
  onClickCloaseModal1(e: MouseEvent) {
    if (e.target == $('.js-modal1')[0]) {
      $('.js-modal1').removeClass('is-active');
    }
  }

  @on({ event: 'click', selector: '.js-modal-open2' })
  onClickOpenModal2() {
    $('.js-modal2').addClass('is-active');
  }

  @on({ event: 'click', selector: '.js-modal2' })
  onClickCloaseModal2(e: MouseEvent) {
    if (e.target == $('.js-modal2')[0]) {
      $('.js-modal2').removeClass('is-active');
    }
  }

  @on({ event: 'click', selector: '.js-modal-open3' })
  onClickOpenModal3() {
    $('.js-modal3').addClass('is-active');
  }

  @on({ event: 'click', selector: '.js-modal3' })
  onClickCloaseModal3(e: MouseEvent) {
    if (e.target == $('.js-modal3')[0]) {
      $('.js-modal3').removeClass('is-active');
    }
  }

  resizerWindow() {
    const resizer = document.querySelector('.resizer');
    const container = document.querySelector('.agreements-scrollarea');
    const resizerPrivacy = document.querySelector('.resizer_privacy');
    const containerPrivacy = document.querySelector(
      '.agreements-scrollarea-privacy',
    );

    function initResize(resizer: HTMLElement, container: HTMLElement) {
      resizer.addEventListener('mousedown', startResize);
      resizer.addEventListener('touchstart', startResize);

      function startResize(event: MouseEvent | TouchEvent) {
        event.preventDefault();

        let startY: number;
        if (event instanceof TouchEvent) {
          startY = event.touches[0].clientY;
        } else {
          startY = event.clientY;
        }

        const startHeight = container.offsetHeight;

        function onMove(e: MouseEvent | TouchEvent) {
          let clientY: number;
          if (e instanceof TouchEvent) {
            clientY = e.touches[0].clientY;
          } else {
            clientY = e.clientY;
          }

          const newHeight = startHeight + (clientY - startY);
          container.style.height = `${newHeight}px`;
        }

        function stopResize() {
          document.removeEventListener('mousemove', onMove);
          document.removeEventListener('mouseup', stopResize);
          document.removeEventListener('touchmove', onMove);
          document.removeEventListener('touchend', stopResize);
        }

        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', stopResize);
        document.addEventListener('touchmove', onMove);
        document.addEventListener('touchend', stopResize);
      }
    }

    if (resizer instanceof HTMLElement && container instanceof HTMLElement) {
      initResize(resizer, container);
    }

    if (
      resizerPrivacy instanceof HTMLElement &&
      containerPrivacy instanceof HTMLElement
    ) {
      initResize(resizerPrivacy, containerPrivacy);
    }
  }
}
